import "./CompositeTrexDeckBuilders.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CommoditySourcing from "./sections/CommoditySourcing";
import SubscriptionBenefits from "./sections/SubscriptionBenefits";
import LightingProjectGallery from "./sections/LightingProjectGallery";
import FutureVisionCta from "./sections/FutureVisionCta";
import Footer from "@/reusable_sections/Footer";
export default function CompositeTrexDeckBuildersPage() {
  return <div>
      <Header />
      <Hero />
      <CommoditySourcing />
      <SubscriptionBenefits />
      <LightingProjectGallery />
      <FutureVisionCta />
      <Footer />
    </div>;
}